import { OrderType, Side } from '@pkg/graphql/codegen/graphql';

export const PREPARE_BUY = {
    type: OrderType.Market,
    side: Side.Bid,
};

export const PREPARE_SELL = {
    type: OrderType.Market,
    side: Side.Ask,
};

export const PREPARE_OFFER = {
    type: OrderType.Limit,
    side: Side.Bid,
};

export const PREPARE_LIST = {
    type: OrderType.Limit,
    side: Side.Ask,
};
